import React from 'react';
import { Paper, Typography, Link as MuiLink, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const NotFoundPage: React.FC = () => (
  <Paper sx={{ p: 4, textAlign: 'center', minHeight: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <Box>
      <Typography variant="h5" gutterBottom>Page Not Found</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        The page you're looking for doesn't exist.
      </Typography>
      <MuiLink component={RouterLink} to="/">
        Back to the converter
      </MuiLink>
    </Box>
  </Paper>
);

export default NotFoundPage;
